import React, { useState } from 'react';
import './Styles.css';
import Modal from '../../../../Elements/ids/Modal';
import { formatMessage } from '../../../../Localization/formatMessage';
import Messages from '../../../../Localization/Messages';
import ErrorMessage from '../../../../Elements/ErrorMessage';
import { ServiceClient } from '../../../../Services/ServiceClient';
import { createServerErrorMessage } from '../../../../Helpers/FormInputHelper';
import { Ui24Delete } from '@ids/react-icons';
import ConnectedTeamsButtons from './Buttons/ConnectedTeamsButtons';
import TeamSearch from './TeamSearch/TeamSearch';
import { useNavigate } from 'react-router-dom';

export const ModalMode = {
  view: 'view',
  error: 'error',
  notFound: 'notFound',
  removeTeam: 'removeTeam',
  connectTeam: 'connectTeam',
};

const ConnectedTeamsModal = ({ employer, setEmployer, closeView }) => {
  const [error, setError] = useState(null);
  const [modalMode, setModalMode] = useState(employer.teams?.length !== 0 ? ModalMode.view : ModalMode.notFound);
  const [selectedTeam, setSelectedTeam] = useState(null);

  const navigate = useNavigate();

  const removeTeamFromEmployer = () => {
    ServiceClient.removeTeamFromEmployer(
      employer.id,
      selectedTeam.codePrefix,
      () => {
        setModalMode(ModalMode.view);
        setEmployer({ ...employer, teams: employer.teams.filter(team => team.codePrefix !== selectedTeam.codePrefix) });
        setSelectedTeam(null);
      },
      error => {
        setModalMode(ModalMode.error);
        setError(createServerErrorMessage(error).message);
      }
    );
  };

  const connectNewTeamToEmployer = () => {
    ServiceClient.connectNewTeamToEmployer(
      employer.id,
      selectedTeam.codePrefix,
      () => {
        setModalMode(ModalMode.view);
        setEmployer({ ...employer, teams: [...employer.teams, { codePrefix: selectedTeam.codePrefix, agents: [] }] });
        setSelectedTeam(null);
      },
      error => {
        setModalMode(ModalMode.error);
        setError(createServerErrorMessage(error).message);
      }
    );
  };

  return (
    <Modal
      closeView={closeView}
      titleText={formatMessage(Messages.employerPage_connectedTeams_title)}
      buttons={
        <ConnectedTeamsButtons
          closeView={closeView}
          modalMode={modalMode}
          removeTeam={removeTeamFromEmployer}
          setModalMode={setModalMode}
          setSelectedTeam={setSelectedTeam}
          connectTeam={connectNewTeamToEmployer}
          connectTeamDisabled={selectedTeam?.codePrefix?.trim().length === 0}
        />
      }>
      {modalMode === ModalMode.view ? (
        <div className="employerPage-connectedTeams-container">
          <div className="common-table-row employerPage-connectedTeams-tableRow headerRow">
            <div>{formatMessage(Messages.common_codePrefix)}</div>
            <div>{formatMessage(Messages.employerPage_connectedTeams_agentCount)}</div>
            <div></div>
          </div>
          {employer.teams?.map((team, index) => {
            return (
              <div
                className={`common-table-row employerPage-connectedTeams-tableRow ${
                  index % 2 === 1 ? 'common-modalTable-evenRow' : ''
                }`}
                key={team.codePrefix}>
                <div
                  className="clickable employerPage-connectedTeams-codePrefix"
                  onClick={() => {
                    navigate(`/team/view/${team.codePrefix}`);
                  }}>
                  {team.codePrefix}
                </div>
                <div>{team.agents?.length}</div>
                <div>
                  <Ui24Delete
                    className="clickable"
                    onClick={() => {
                      setModalMode(ModalMode.removeTeam);
                      setSelectedTeam(team);
                    }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      ) : modalMode === ModalMode.removeTeam ? (
        <div className="employerPage-connectedTeams-text">
          {formatMessage(Messages.employerPage_connectedTeams_removeTeamWarning, {
            codePrefix: selectedTeam?.codePrefix,
          })}
        </div>
      ) : modalMode === ModalMode.connectTeam ? (
        <TeamSearch selectedTeam={selectedTeam} setSelectedTeam={setSelectedTeam} existingTeams={employer.teams} />
      ) : modalMode === ModalMode.notFound ? (
        <div className="employerPage-connectedTeams-text">
          {formatMessage(Messages.employerPage_connectedTeams_notFound)}
        </div>
      ) : modalMode === ModalMode.error ? (
        <div className="employerPage-connectedTeams-text">
          <ErrorMessage message={error} />
        </div>
      ) : null}
    </Modal>
  );
};

export default ConnectedTeamsModal;
